import { useState } from "react";
import { Link } from "react-router-dom";
import { chipName, formatCreditBalance } from "../../../utils/sharedFunctions";
import InfiniteScroll from "react-infinite-scroll-component";
import { transactionFilters } from "../../../services/transactionService";
import { approveAggregatorTransaction, rejectAggregatorTransaction } from "../../../services/supplierService";
import { errorToast, successToast } from "../../Toasts/Toasts";
import localStorageStore from "../../../utils/localStorageStore";
import { userRoleConstants } from "../../../utils/constants";
import moment from "moment";

const SupplierTransactionTable = ({ transactions, transactionsLoading, setShowAddTransaction, setShowTransactionFilter, setShowBillingLog, setSelectedTransaction, onExport, activeFilters, onChipRemove, infiniteScrollProps, onSuccess }) => {
  const isAccountant = parseInt(localStorageStore.getRole()) === userRoleConstants.ACCOUNTANT_ID;
  const [actionLoading, setActionLoading] = useState(null);

  const handleApprove = async (transaction) => {
    setActionLoading(`approve-${transaction.id}`);
    try {
      await approveAggregatorTransaction(transaction.id, "");
      successToast("Transaction approved successfully");
      onSuccess?.();
    } catch {
      errorToast("Failed to approve transaction");
    } finally {
      setActionLoading(null);
    }
  };

  const handleReject = async (transaction) => {
    setActionLoading(`reject-${transaction.id}`);
    try {
      await rejectAggregatorTransaction(transaction.id, "");
      successToast("Transaction rejected successfully");
      onSuccess?.();
    } catch {
      errorToast("Failed to reject transaction");
    } finally {
      setActionLoading(null);
    }
  };
  const chips = Object.entries(activeFilters || {}).filter(([key]) => key !== "endDate");
  
  const statusMap = {
    approved: "bg-success",
    pending: "bg-warning",
    rejected: "bg-danger",
    cancelled: "bg-secondary"
  };
  return (
    <div className="row g-2">
      <div className="col-md-12">
        <div className="card">
          <div className="card-header pb-1 pt-2 border-bottom d-flex justify-content-between">
            <div className="w-100 d-flex align-items-center justify-content-between">
              <div className="d-flex">
                <h5 className="card-title mb-0 me-3">Transactions</h5>
                <button type="button" className="btn btn-sm btn-secondary btn-icon rounded-pill waves-effect waves-light" onClick={() => setShowAddTransaction(true)}>
                  <i className="ti ti-plus"></i>
                </button>
              </div>
              <div className="d-flex">
                {chips.length > 0 && (
                  <div className="card-header pt-1 pb-2 border-bottom">
                    <div className="filter-card" style={{ display: "block" }}>
                      {chips.map(([key, value]) => (
                        <div className="chip" key={key}>
                          <input type="checkbox" name="filters[]" defaultValue="a" defaultChecked="" readOnly />
                          <span>
                            {chipName(key)} {":"} {key === "startDate" ? `${value} - ${activeFilters.endDate}` : value}
                          </span>
                          <button type="button" className="zap">
                            <i className="ti ti-x fs-6" onClick={() => onChipRemove(key)} />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <button type="button" className="btn btn-sm btn-primary waves-effect waves-light" onClick={() => setShowTransactionFilter(true)}>
                  <i className="ti ti-filter"></i>
                </button>
                <button type="button" className="btn btn-sm btn-outline-secondary rounded-pill btn-sm waves-effect waves-light ms-2" onClick={onExport}>
                  <i className="ti ti-download me-1"></i>
                  Export
                </button>
              </div>
            </div>
          </div>
          <div className="card-datatable table-responsive" id="supplierTransactionTable" style={{ height: '400px', overflow: 'auto' }}>
            <InfiniteScroll
              dataLength={infiniteScrollProps?.dataLength || transactions.length}
              next={infiniteScrollProps?.next}
              hasMore={infiniteScrollProps?.hasMore || false}
              loader={infiniteScrollProps?.loader}
              scrollableTarget="supplierTransactionTable"
              height={infiniteScrollProps?.height || 400}
            >
              <table className="table table-fixed" id="orders">
                <thead className="fixed-table-header">
                  <tr>
                    <th>ID</th>
                    <th>Type</th>
                    <th>Amount (USD)</th>
                    <th>Amount (Local)</th>
                    <th>Exchange Rate</th>
                    <th>Commission</th>
                    <th>Created By</th>
                    <th>Approved By</th>
                    <th>Bank</th>
                    <th>Status</th>
                    {!isAccountant && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {transactions.length === 0 && !transactionsLoading && (
                    <tr>
                      <td colSpan="10" className="text-center text-muted py-4">No records found</td>
                    </tr>
                  )}
                  {transactions.map((transaction) => (
                    <tr key={transaction.id}>
                      <td>
                        <Link onClick={() => {
                          setSelectedTransaction(transaction);
                          setShowBillingLog(true);
                        }}>
                          {transaction.id} <br />
                          <small className="text-muted">{transaction?.date}</small>
                        </Link>
                      </td>
                      <td>{transaction?.type}</td>
                      <td className="text-end">
                        {formatCreditBalance(transaction?.amount_usd, 2)} <br />
                        <small className="text-muted">USD</small>
                      </td>
                      <td className="text-end">
                        {formatCreditBalance(transaction?.amount_local, 2)} <br />
                        <small className="text-muted">{transaction?.local_currency}</small>
                      </td>
                      <td className="text-end">{formatCreditBalance(transaction?.exchange_rate, 4)}</td>
                      <td className="text-end">{transaction?.commission}</td>
                      <td style={{ width: '13%' }}>
                        {transaction?.created_by?.name} <br />
                        <small className="text-muted">{transaction?.createdAt ? moment.utc(transaction.createdAt).format("DD MMM YY, hh:mm A") : ""}</small>
                      </td>
                      <td >
                        {transaction.approved_by?.name} <br />
                        <small className="text-muted">{transaction?.approved_at ? moment.utc(transaction.approved_at).format("DD MMM YY, hh:mm A") : ""}</small>
                      </td>
                      <td>
                        {transaction?.BankAccount?.bank_name} <br />
                        <small className="text-muted">{transaction?.bankAccount}</small>
                      </td>
                      <td>
                        <span className={`badge px-2 text-capitalize ${statusMap[transaction?.status?.toLowerCase()]}`}>
                          {transaction?.status || "Unknown"}
                        </span>
                      </td>

                      {!isAccountant && (
                        <td>
                          <div className="btn-group" role="group" aria-label="First group">
                            {!transaction.cancelled_by_id && !transaction.approved_by_id && !transaction.rejected_by_id && (
                              <button type="button" className="btn btn-sm btn-outline-actions waves-effect" title="Approve" disabled={!!actionLoading} onClick={() => handleApprove(transaction)}>
                                <i className="ti ti-check text-success"></i>
                              </button>
                            )}
                            {!transaction.cancelled_by_id && !transaction.approved_by_id && !transaction.rejected_by_id && (
                              <button type="button" className="btn btn-sm btn-outline-actions waves-effect" title="Reject" disabled={!!actionLoading} onClick={() => handleReject(transaction)}>
                                <i className="ti ti-x text-danger"></i>
                              </button>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SupplierTransactionTable;
